import { getAllBooks } from '@/db/queries';
import { getBookCover, getPlaceholderImage, slugify } from '@/lib/utils';

<!-- Header -->
<div class="border-b">
  <div class="container mx-auto px-4">
    <div class="flex flex-col gap-4 py-6">
      <h1 class="text-3xl font-bold capitalize">Browse Books</h1>
    </div>
  </div>
</div>

<!-- Books Grid -->
<main class="container mx-auto px-4 py-8">

  <try>
    <@placeholder>
      <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
        <!-- Loading skeleton cards -->
        <for|i| of=[1, 2, 3, 4, 5, 6]>
          <div class="rounded-lg border bg-card shadow-sm overflow-hidden">
            <div class="relative aspect-[2/3] bg-muted animate-pulse"></div>
            <div class="p-4">
              <div class="h-6 bg-muted rounded mb-2 animate-pulse"></div>
              <div class="h-4 bg-muted rounded w-2/3 animate-pulse"></div>
            </div>
          </div>
        </for>
      </div>
    </@placeholder>

    <@catch|error|>
      <div class="text-center py-12">
        <div class="inline-flex items-center justify-center w-12 h-12 rounded-full bg-destructive/10 text-destructive mb-4">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        </div>
        <h2 class="text-xl font-semibold mb-2">Failed to load books</h2>
        <p class="text-muted-foreground mb-4">
          ${error instanceof Error ? error.message : 'An error occurred while loading the books.'}
        </p>
        <button
          onClick() { window.location.reload(); }
          class="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90"
        >
          Try Again
        </button>
      </div>
    </@catch>

    <await|bookList|=getAllBooks()>
      <if=bookList.length === 0>
        <div class="text-center py-12">
          <div class="inline-flex items-center justify-center w-12 h-12 rounded-full bg-muted mb-4">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
              <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
            </svg>
          </div>
          <h2 class="text-xl font-semibold mb-2">No books found</h2>
          <p class="text-muted-foreground">Start by adding some books to your collection.</p>
        </div>
      </if>
      <else>
        <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
          <for|book| of=bookList>
            <const/coverPath=getBookCover(book)>
            <const/placeholderPath=getPlaceholderImage()>
            <const/bookSlug=slugify(book.title)/>
            <const/bookUrl=`/books/${book.id}/${bookSlug}`>
            <const/bookAuthor=book.author || ''>
            <const/onErrorScript=`this.src='${placeholderPath}'`>
            <const/bookType=book.type || 'comic'>

            <a href=bookUrl>
              <div class="group rounded-lg border bg-card shadow-sm hover:shadow-xl transition-shadow overflow-hidden h-full">
                <div class="p-0">
                  <div class="relative aspect-[2/3] overflow-hidden">
                    <img
                      src=coverPath
                      alt=book.title
                      onerror=onErrorScript
                      class="object-cover transition-transform group-hover:scale-105 w-full h-full"
                    />
                    <div class="absolute top-2 left-2">
                      <span class="bg-background/80 backdrop-blur-sm capitalize px-2 py-1 rounded text-xs font-medium">
                        ${bookType}
                      </span>
                    </div>
                  </div>
                  <div class="p-4">
                    <h3 class="font-bold mb-1 group-hover:text-primary transition-colors">
                      ${book.title}
                    </h3>
                    <p class="text-sm text-muted-foreground">${bookAuthor}</p>
                  </div>
                </div>
              </div>
            </a>
          </for>
        </div>
      </else>
    </await>
  </try>
</main>
